import Search from "../Search/Search";

import menuIcon from "../../assets/menu-icon.png"

import "./style.css"

export const Header = () => {

	return (
		<div className="header">
			<button className="header-button">
				<img src={menuIcon} alt="menu-icon" />
			</button>
			<div>
				<Search width="320px" text="Suchen" backgroundColor="#E3E3E3"/>
			</div>
		</div>
	)
}
